import { Observable } from 'rxjs'
import { merge, materialize, dematerialize, pairwise, map } from 'rxjs/operators'

/*
    Similar to merge except that if either of the streams completes/errors
    then the resulting stream will also complete/error
*/
export function mergeWithCompletion<T>(obs: Observable<T>) {
  return <S>(source: Observable<S>) => {
    return source.pipe(materialize(), merge(obs.pipe(materialize())), dematerialize())
  }
}

/*
    Returns the penultimate emitted value    
*/
export function penultimate() {
  return <S>(source: Observable<S>) => {
    return source.pipe(
      pairwise(),
      map(pair => pair[0])
    )
  }
}
